<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/kjopsbetingelser" />
</template>
